import React from 'react'
import Aboutheader from './Aboutheader'
import Aboutusdetail from './Aboutusdetail'

const About = () => {
  return (
    <div>
      <Aboutheader/>
      <Aboutusdetail/>
    </div>
  )
}

export default About